'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from '@/hooks/useTranslations';
import { EXTERNAL_LINKS } from '@/constants/routes';
import './LookingForWorkSection.scss';

export default function LookingForWorkSection() {
  const { t } = useTranslation();

  return (
    <section
      id="looking-for-work"
      className="looking-for-work-section"
      aria-labelledby="looking-for-work-section-title"
    >
      <div className="looking-for-work-section__inner">
        <p className="looking-for-work-section__label">
          {t('lookingForWork.label')}
        </p>

        <h2
          id="looking-for-work-section-title"
          className="looking-for-work-section__title"
        >
          {t('lookingForWork.titleLine1')}
          <br />
          {t('lookingForWork.titleLine2')}
        </h2>

        <p className="looking-for-work-section__subtitle">
          {t('lookingForWork.subtitle')}
        </p>

        <div className="looking-for-work-section__stores">
          <Link
            href={EXTERNAL_LINKS.APP_STORE}
            className="looking-for-work-section__store-link"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t('lookingForWork.appStoreAriaLabel')}
          >
            <Image
              src="/appstore-img.png"
              alt=""
              width={168}
              height={56}
              className="looking-for-work-section__store-image"
            />
          </Link>

          <Link
            href={EXTERNAL_LINKS.GOOGLE_PLAY}
            className="looking-for-work-section__store-link"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t('lookingForWork.googlePlayAriaLabel')}
          >
            <Image
              src="/google-img.png"
              alt=""
              width={168}
              height={56}
              className="looking-for-work-section__store-image"
            />
          </Link>
        </div>
      </div>
    </section>
  );
}
